import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from 'components/Card'
import { observer } from 'mobx-react'
import JobViewModel from '../JobViewModel'
import CollaboratorItem from './CollaboratorItem'
import RequestedProvider from './RequestedPovider'
import { IconButton } from 'components/IconButton'
import Icon from 'components/Icon'
import {
  DropdownTitle,
  DropdownItem,
  Dropdown,
  DropdownItemTitle,
} from 'components/Dropdown'
import styles from './CollaboratorsCard.sass'

interface Props {
  vm: JobViewModel
}
export default observer(function CollaboratorsCard({ vm }: Props) {
  return (
    <Card>
      <CardHeader>
        <div className={styles.cardHeader}>
          <CardTitle dataTest="collaborators-tab-item">Collaborators</CardTitle>
          {vm.canViewCollaboratorActionsMenu && (
            <Dropdown
              autoDismiss
              dataTest="collaborators-card-dropdown-menu"
              button={
                <IconButton>
                  <Icon name="more" rotate={90} />
                </IconButton>
              }
            >
              <DropdownTitle>Actions</DropdownTitle>

              {vm.canAddCollaboratorsAsAdmin && (
                <DropdownItem
                  icon={<Icon name="add" />}
                  onClick={vm.addCollaboratorsAsAdminVM.show}
                  data-test="collaborators-add-pro-dropdown-item"
                >
                  <DropdownItemTitle>Add collaborator</DropdownItemTitle>
                </DropdownItem>
              )}

              {!vm.canAddClientsAsAdmin && vm.canAddClientsAsTeamMember && (
                <DropdownItem
                  icon={<Icon name="add" />}
                  onClick={vm.addClientsAsTeamMemberVM.show}
                  data-test="collaborators-add-client-dropdown-item"
                >
                  <DropdownItemTitle>Add client</DropdownItemTitle>
                </DropdownItem>
              )}

              {vm.ratingsVM.canRatePro && (
                <DropdownItem
                  icon={<Icon name="ratings" />}
                  onClick={vm.ratingsVM.showRateProDialog}
                  data-test="collaborators-rate-pro-dropdown-item"
                >
                  <DropdownItemTitle>Rate pro</DropdownItemTitle>
                </DropdownItem>
              )}

              {vm.canRemoveCollaboratorsAsAdmin && (
                <DropdownItem
                  icon={<Icon name="delete" />}
                  onClick={vm.removeCollaboratorsAsAdminVM.show}
                  data-test="collaborators-remove-pro-dropdown-item"
                >
                  <DropdownItemTitle>Remove collaborator</DropdownItemTitle>
                </DropdownItem>
              )}

              {!vm.canRemoveClientsAsAdmin && vm.canRemoveClientsAsNonAdmin && (
                <DropdownItem
                  icon={<Icon name="delete" />}
                  onClick={vm.removeClientsAsNonAdminVM.show}
                  data-test="collaborators-remove-clients-dropdown-item"
                >
                  <DropdownItemTitle>Remove client</DropdownItemTitle>
                </DropdownItem>
              )}
            </Dropdown>
          )}
        </div>
      </CardHeader>
      <CardContent scroll compact>
        <Collaborators vm={vm} />
      </CardContent>
    </Card>
  )
})

interface CollaboratorsProps {
  vm: JobViewModel
}

const Collaborators = observer(({ vm }: CollaboratorsProps) => {
  return (
    <>
      {vm.collaborators.map((collaborator) => (
        <CollaboratorItem
          key={collaborator.member.user.id}
          collaborator={collaborator}
          vm={vm}
        />
      ))}

      {vm.showingRequestedProvider && (
        <RequestedProvider provider={vm.job.requestedPro!} vm={vm} />
      )}
    </>
  )
})
